export default __webpack_public_path__ + "static/media/manwithsmile.bfcc8f4f.png";